import React from 'react';
import { NotificationItemButtonProps } from '../notification-item/notification-item';
import notificationError from '../../../../assets/notification-error.svg';
import { NotificationsFragment } from '../../../../models/experiencefragments/vehicle-notifications';
import {
    DetailedNotificationItem,
    ListItem,
} from '../detailed-notification-item/detailed-notification-item';
import { useAnalytics } from '../../../../hooks/use-analytics';
import AppConfigurationService from '../../../../services/app-configuration-service/app-configuration-service';
import { BRAND } from '../../../../constants';
import { PreImagineDetailedNotificationItem } from '../detailed-notification-item/pre-imagine-detailed-notification-item';

interface Props {
    recallDetails: ListItem[];
    content: NotificationsFragment | null;
    vin?: string;
}
export const RecallsNotification = (props: Props) => {
    const { content, vin } = props;
    const ctaHref = (): string | undefined => {
        if (content?.recalls?.ctaUrl?.includes('%vin') && vin) {
            return content.recalls.ctaUrl.replace('%vin', vin);
        }
        return content?.recalls?.ctaUrl;
    };
    const [fireEvents] = useAnalytics();
    const recallOnClickAnalytics = () => {
        fireEvents(
            ['notifications-cta-onclick-event'],
            undefined,
            {
                notificationCategory: 'recall',
                notificationCtaName: content?.recalls?.ctaTitle.toLowerCase(),
            },
            false
        );
    };

    const buttonProps: NotificationItemButtonProps &
        React.HTMLProps<HTMLAnchorElement> = {
        link: ctaHref(),
        linkTarget: content?.recalls?.targetBlank ? '_blank' : '_self',
        children: <>{content?.recalls?.ctaTitle}</>,
        onClick: () => recallOnClickAnalytics(),
    };
    const getHeadText = (): string | undefined => {
        return content?.recalls?.recallsTitle?.toUpperCase();
    };
    const getIconPath = (): string => {
        if (!content?.recalls?.iconPath) return notificationError;
        return process.env.REACT_APP_AEM_BASE_URL + content?.recalls?.iconPath;
    };

    const getDetailedIconPath = (): string => {
        if (!content?.recalls?.detailedIconPath) return notificationError;
        return (
            process.env.REACT_APP_AEM_BASE_URL +
            content?.recalls?.detailedIconPath
        );
    };
    const appConfig = new AppConfigurationService().getAppConfiguration();
    const currentVersion = appConfig.brand === BRAND.lincoln.LONG_NAME;
    return (
        <>
            {currentVersion ? (
                <DetailedNotificationItem
                    notificationDetails={props.recallDetails}
                    headText={getHeadText()}
                    subText={content?.recalls?.description}
                    iconPath={getIconPath()}
                    detailedIconPath={getDetailedIconPath()}
                    buttonProps={buttonProps}
                    category={getHeadText()}
                />
            ) : (
                <PreImagineDetailedNotificationItem
                    notificationDetails={props.recallDetails}
                    headText={getHeadText()}
                    subText={content?.recalls?.description}
                    iconPath={getIconPath()}
                    detailedIconPath={getDetailedIconPath()}
                    buttonProps={buttonProps}
                    category={getHeadText()}
                />
            )}
        </>
    );
};
